import React from 'react';
import styles from "./not-found.module.css";
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className={styles["not-found-container"]}>
      <div className={styles["not-found-img"]}>
        <img src='/assets/images/404.svg' alt='404' />
      </div>
      <p className={styles["not-found-header"]}>
        {'404 Page not found'}
      </p>
      <p className={styles["not-found-details"]}>
        {'This page doesn’t exist or may have been removed. Please go back to the '}
        <Link to="/" className={styles["dashboard-link"]}>
          Dashboard
        </Link>
        {' instead.'}
      </p>
    </div>
  );
};

export default NotFound;
